// extracted by mini-css-extract-plugin
export default {"mainTemplateWrapper":"MainTemplate_mainTemplateWrapper__Q5i+A"};